/**
 * src/components/layout/ProtectedRoute.jsx
 * Guard de rutas — redirige a /login si no hay token.
 */
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'

export function ProtectedRoute({ children }) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)
  const location = useLocation()

  if (!isAuthenticated) {
    // Guardar la ruta original para redirigir después del login
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}
